import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitFoundingMember(payload) {
  const { data } = await api.post("/founding-members", payload);
  return data;
}

export async function fetchFoundingCount() {
  const { data } = await api.get("/founding-members/count");
  return data;
}

export async function fetchFoundingStats() {
  const { data } = await api.get("/founding-stats");
  return data;
}
